export default "__VITE_ASSET__CJYRzdpg__"